import { Injectable } from '@angular/core'
import { CommonService } from './common.service'
import { LocalStorageService } from './local-storage.service'
import { environment } from "src/environments/environment";
import { GlobalConstants } from "src/app/constants/global-constants";
import { JWTService } from './jwt.service'

@Injectable({
  providedIn: 'root'
})
export class AuthService {
  private static token_prefix = environment.token_prefix
  private static readonly TOKEN_KEY = AuthService.token_prefix + 'auth-token'
  private static readonly REFRESH_TOKEN_KEY = 'refresh'

  constructor(private cs: CommonService, private jwtService: JWTService) {}

  public static getToken(): string {
    return LocalStorageService.get(AuthService.TOKEN_KEY)
  }

  public static getRefreshToken(): string {
    return LocalStorageService.get(AuthService.REFRESH_TOKEN_KEY)
  }

  public static setToken(token: string) {
    LocalStorageService.set(AuthService.TOKEN_KEY, token)
  }

  public static setRefreshToken(token: string) {
    LocalStorageService.set(AuthService.REFRESH_TOKEN_KEY, token)
  }

  public static deleteToken() {
    LocalStorageService.remove(AuthService.TOKEN_KEY)
  }

  logout() {
    AuthService.deleteToken()
    this.cs.routeTo(GlobalConstants.ROUTING.LOGIN)
  }

  redirectToLogin() {
    this.cs.routeTo(GlobalConstants.ROUTING.LOGIN)
  }

  isUserAuthenticated(): boolean {
    const token = AuthService.getToken()
    if (!token) {
      return false
    }
    return true
  }

  getUser() {
    return this.jwtService.decodeToken(LocalStorageService.get(AuthService.TOKEN_KEY))
  }
}
